import type {DeploymentConfig} from '../deploy/types.js';

import {deployDefaults} from './utils.js';

export const testToken = {
  accessToken: 'some_token',
  allowedResource: 'gid://oxygen-hub/Namespace/1',
  appId: 'gid://oxygen-hub/App/1',
  client: 'gid://oxygen-hub/Client/1',
  expiresAt: '2023-04-08T09:38:50.368Z',
  namespace: 'fresh-namespace',
  namespaceId: 'gid://oxygen-hub/Namespace/1',
};

export function createTestConfig(rootFolder: string): DeploymentConfig {
  return {
    assetsDir: '/assets/',
    bugsnag: false,
    buildCommand: String(deployDefaults.buildCommandDefault!),
    defaultEnvironment: false,
    deploymentToken: testToken,
    environmentTag: 'environment',
    deploymentUrl: 'https://localhost:3000',
    metadata: {},
    rootPath: rootFolder,
    skipBuild: false,
    workerDir: '/worker/',
    workerOnly: false,
    generateAuthBypassToken: false,
  };
}
